var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import { Actions, Effect } from "@ngrx/effects";
import { Observable } from "rxjs/Observable";
import { SettingsService } from "./settings.service";
import * as SettingsActions from "../user/user.actions";
import { NotificationsService } from "angular2-notifications";
import { S3Service } from "../../services/s3.service";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators/map";
import { catchError } from "rxjs/operators/catchError";
var SettingsEffects = /** @class */ (function () {
    function SettingsEffects(actions$, settingsService, notificationService, s3Service, translate) {
        var _this = this;
        this.actions$ = actions$;
        this.settingsService = settingsService;
        this.notificationService = notificationService;
        this.s3Service = s3Service;
        this.translate = translate;
        this.save = this.actions$
            .ofType(SettingsActions.ActionTypes.SAVE_SETTINGS)
            .map(function (action) { return action.payload; })
            .switchMap(function (settings) {
            if (settings.logoFile) {
                return _this.s3Service
                    .putFileToS3("logos", settings.logoFile)
                    .map(function (url) {
                    settings.logo = url;
                    delete settings.logoFile;
                    return settings;
                });
            }
            else {
                settings.logo = null;
                return Observable.of(settings);
            }
        })
            .switchMap(function (settings) {
            return _this.settingsService.updateSettings(settings).pipe(map(function (_settings) {
                return new SettingsActions.SaveSettingsSuccessAction(_settings);
            }), catchError(function () {
                return Observable.of(new SettingsActions.SaveSettingsFailAction());
            }));
        })
            .catch(function () {
            _this.notificationService.error("Problem occurred uploading logo");
            return Observable.of(null);
        });
        this.save_success = this.actions$
            .ofType(SettingsActions.ActionTypes.SAVE_SETTINGS_SUCCESS)
            .map(function (action) { return action.payload; })
            .switchMap(function (settings) {
            // change language
            var currentLanguage = _this.translate.currentLang;
            var lang = settings.language.substring(0, 2);
            localStorage.setItem("lang", lang);
            _this.translate.use(lang);
            if (currentLanguage !== lang) {
                // we need to reload language
                location.reload();
            }
            return Observable.of(_this.notificationService.success(_this.translate.instant("settings.notifications.save_success.title"), _this.translate.instant("settings.notifications.save_success.text")));
        });
        this.save_fail = this.actions$
            .ofType(SettingsActions.ActionTypes.SAVE_SETTINGS_FAIL)
            .switchMap(function () {
            return Observable.of(_this.notificationService.error(_this.translate.instant("settings.notifications.save_fail.title"), _this.translate.instant("settings.notifications.save_fail.text")));
        });
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], SettingsEffects.prototype, "save", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], SettingsEffects.prototype, "save_success", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], SettingsEffects.prototype, "save_fail", void 0);
    return SettingsEffects;
}());
export { SettingsEffects };



// WEBPACK FOOTER //
// /app/src/app/core/store/settings/settings.effects.ts.pre-build-optimizer.js